import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [{
        path: "/",
        name: "Home",
        component: () =>
            import ("../views/Home.vue"),
    },
    {
        path: "/Identity",
        name: "Identity",
        component: () =>
            import ("../views/Identity/Identity.vue"),
    },
    {
        path: "/Curriculum",
        name: "Curriculum",
        component: () =>
            import ("../views/Curriculum/Curriculum.vue"),
    },
    {
        path: "/CurriculumSetMeal",
        name: "CurriculumSetMeal",
        component: () =>
            import ("../views/CurriculumSetMeal/CurriculumSetMeal.vue"),
    },
    {
        path: "/CurriculumSetMealInfo",
        name: "CurriculumSetMealInfo",
        component: () =>
            import ("../views/CurriculumSetMealInfo/CurriculumSetMealInfo.vue"),
    },
    {
        path: "/OrderOk",
        name: "OrderOk",
        component: () =>
            import ("../views/OrderOk/OrderOk.vue"),
    },
    {
        path: "/Pay",
        name: "Pay",
        component: () =>
            import ("../views/Pay/Pay.vue"),
    },
    {
        path: "/CurriculumVideo",
        name: "CurriculumVideo",
        component: () =>
            import ("../views/CurriculumVideo/CurriculumVideo.vue"),
    },
    {
        path: "/Examination",
        name: "Examination",
        component: () =>
            import ("../views/Examination/Examination.vue"),
    },
    {
        path: "/ExaminationIdentity",
        name: "ExaminationIdentity",
        component: () =>
            import ("../views/ExaminationIdentity/ExaminationIdentity.vue"),
    },
    {
        path: "/ExaminationIdentityOk",
        name: "ExaminationIdentityOk",
        component: () =>
            import ("../views/ExaminationIdentityOk/ExaminationIdentityOk.vue"),
    },
    {
        path: "/ExaminationInfo",
        name: "ExaminationInfo",
        component: () =>
            import ("../views/ExaminationInfo/ExaminationInfo.vue"),
    },
    {
        path: "/ExaminationBook",
        name: "ExaminationBook",
        component: () =>
            import ("../views/ExaminationBook/ExaminationBook.vue"),
    },
    {
        path: "/ExaminationResult",
        name: "ExaminationResult",
        component: () =>
            import ("../views/ExaminationResult/ExaminationResult.vue"),
    },
    {
        path: "/bindPhone",
        name: "bindPhone",
        component: () =>
            import ("../views/bindPhone/bindPhone.vue"),
    },
	{
	    path: "/bindPhoneInfor",
	    name: "bindPhoneInfor",
	    component: () =>
	        import ("../views/bindPhone/bindPhone-infor.vue"),
	},
    {
        path: "/retrievePw",
        name: "retrievePw",
        component: () =>
            import ("../views/retrievePw/retrievePw.vue"),
    },
    {
        path: "/attendanceProcess",
        name: "AttendanceProcess",
        component: () =>
            import ("../views/userCenter/AttendanceProcess.vue"),
        children: [{
                path: "combo",
                name: "Combo",
                component: () =>
                    import ("../components/userCenter/Combo.vue"),
            },
            {
                path: "course",
                name: "Course",
                component: () =>
                    import ("../components/userCenter/Course.vue"),
            },
            {
                path: "test",
                name: "Test",
                component: () =>
                    import ("../components/userCenter/Test.vue"),
            },
            {
                path: "testRecord",
                name: "TestRecord",
                component: () =>
                    import ("../components/userCenter/TestRecord.vue"),
            },
            {
                path: "proof",
                name: "Proof",
                component: () =>
                    import ("../components/userCenter/Proof.vue"),
            },
            {
                path: "proofImg",
                name: "ProofImg",
                component: () =>
                    import ("../components/userCenter/ProofImg.vue"),
            },
            {
                path: "order",
                name: "Order",
                component: () =>
                    import ("../components/userCenter/Order.vue"),
            },
            {
                path: "myInvoice",
                name: "myInvoice",
                component: () =>
                    import ("../components/userCenter/myInvoice.vue"),
            },
            {
                path: "problem",
                name: "Problem",
                component: () =>
                    import ("../components/userCenter/Problem.vue"),
            },
            {
                path: "eval",
                name: "Eval",
                component: () =>
                    import ("../components/userCenter/Eval.vue"),
            },
            {
                path: "addProblem",
                name: "AddProblem",
                component: () =>
                    import ("../components/userCenter/AddProblem.vue"),
            },
        ],
    },
    {
        path: "/orderDetail",
        name: "OrderDetail",
        component: () =>
            import ("../views/userCenter/OrderDetail.vue"),
    },
    {
        path: "/userSet",
        name: "UserSet",
        component: () =>
            import ("../views/userCenter/UserSet.vue"),
        children: [{
                path: "setMyInfo",
                name: "SetMyInfo",
                component: () =>
                    import ("../components/userSet/SetMyInfo.vue"),
            },
            {
                path: "myInfo",
                name: "MyInfo",
                component: () =>
                    import ("../components/userSet/MyInfo.vue"),
            },
            {
                path: "checkIdCar",
                name: "CheckIdCar",
                component: () =>
                    import ("../components/userSet/CheckIdCar.vue"),
            },
            {
                path: "checkAptitude",
                name: "CheckAptitude",
                component: () =>
                    import ("../components/userSet/CheckAptitude.vue"),
            },
            {
                path: "phoneBind",
                name: "PhoneBind",
                component: () =>
                    import ("../components/userSet/PhoneBind.vue"),
            },
            {
                path: "editPassword",
                name: "EditPassword",
                component: () =>
                    import ("../components/userSet/EditPassword.vue"),
            },
        ],
    },
    {
        path: "/news",
        name: "News",
        component: () =>
            import ("../views/News.vue"),
    },
    {
        path: "/newsDetail",
        name: "NewsDetail",
        component: () =>
            import ("../views/NewsDetail.vue"),
    },
    {
        path: "/help",
        name: "Help",
        component: () =>
            import ("../views/help/Help.vue"),
        children: [{
                path: "helpList",
                name: "HelpList",
                component: () =>
                    import ("../views/help/HelpList.vue"),
            },
            {
                path: "helpDetail",
                name: "HelpDetail",
                component: () =>
                    import ("../views/help/HelpDetail.vue"),
            },
        ],
    },

    {
        path: "/message",
        name: "message",
        component: () =>
            import ("../views/userCenter/Message.vue"),
        children: [{
                path: "msgList",
                name: "MsgList",
                component: () =>
                    import ("../components/message/MsgList.vue"),
            },
            {
                path: "msgDetail",
                name: "MsgDetail",
                component: () =>
                    import ("../components/message/MsgDetail.vue"),
            },
        ],
    },
    {
        path: "/notice",
        name: "notice",
        component: () =>
            import ("../views/education/Notice.vue"),
    },
    {
        path: "/noticeDetail",
        name: "noticeDetail",
        component: () =>
            import ("../views/education/NoticeDetail.vue"),
    },
	{
		path: "/apk",
		name: "apk",
		component: () =>
			import ("../views/app/apk.vue"),
	},
];

const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    // base: "/aierxin/",
    routes,
    // 路由跳转时自动回到顶部
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        }
        return {
            x: 0,
            y: 0,
        };
    },
});
//router.beforeEach((to, from, next) => {
//
//})
export default router;